export const getProduct = `
  query GetProduct($entityId: String!) {
    getProduct(entityId: $entityId) {
      entityId
      stripeId
      paymentType
      defaultPrice {
        stripeId
      }
    }
  }
`

export const getCurrentCustomer = `
  query GetCurrentCustomer {
    getCurrentCustomer {
      entityId
      stripeId
      trialEnd
      createdAt
      ownedProducts
    }
  }
`

export const verifyActiveSubscriptions = `
  query VerifyActiveSubscriptions(
    $productIds: [String!]!
  ) {
    verifyActiveSubscriptions (
      productIds: $productIds
    ) {
      activeSubscriptions
    }
  }
`
